module.exports = __webpack_public_path__ + "img/stepicons-install-intake.191d2366.svg";